package app.bloomey.web.modules.analytics

import app.bloomey.web.core.data.UiState
import app.bloomey.web.core.data.models.TimeSeriesQuery
import app.bloomey.web.core.data.models.TimesSeriesData
import app.bloomey.web.utils.ApiError
import kotlinx.coroutines.flow.flow

class AnalyticsRepository {
    private val api = AnalyticsApi()

    suspend fun totalUsers(query: TimeSeriesQuery) = flow<UiState<List<TimesSeriesData<Long>>>> {
        try {
            emit(UiState.Loading)
            val response = api.totalUsers(query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e, "Unable to get Series")))
        }
    }

    suspend fun activeUsers(query: TimeSeriesQuery) = flow<UiState<List<TimesSeriesData<Long>>>> {
        try {
            emit(UiState.Loading)
            val response = api.activeUsers(query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e, "Unable to get Series")))
        }
    }

    suspend fun newUsers(query: TimeSeriesQuery) = flow<UiState<List<TimesSeriesData<Long>>>> {
        try {
            emit(UiState.Loading)
            val response = api.newUsers(query)
            emit(UiState.Success(response.data))
        } catch (e: Throwable) {
            emit(UiState.Error(ApiError.parseMessage(e, "Unable to get Series")))
        }
    }
}